import * as React from 'react';
import s from '../responsive.scss';
import classNames from 'classnames';
export var ShowOnMobileOnly = function (props) {
    var classes = classNames(s.mobileOnly, props.className);
    return React.createElement("div", { className: classes }, props.children);
};
//# sourceMappingURL=ShowOnMobileOnly.js.map